import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CvdDongleInfo } from '../../models';
import { CvdDongleAlert } from './../../models';

@Injectable({
  providedIn: 'root'
})
export class CvdDongleService {
  constructor(private readonly httpClient: HttpClient) { }

  public getCvdDongleInfo(): Observable<CvdDongleInfo[]> {
    const url = 'api/cvddongleinfo';
    return this.httpClient.get<CvdDongleInfo[]>(url);
  }

  public getCvdDongleAlerts(): Observable<CvdDongleAlert[]> {
    const url = 'api/cvddongleinfo/alerts';
    return this.httpClient.get<CvdDongleAlert[]>(url);
  }
}
